import { useRef } from "react";
import { useTimelineContext } from "../../remotion-timeline/context/use-timeline-context";

import ContentEditable from "react-contenteditable";
import { ItemType } from "../../remotion-timeline/types";

export const TextItem = ({ item }: { item: ItemType }) => {
  if (item.type !== "text") {
    throw new Error("Item is not a text");
  }

  const contentEditableRef = useRef<any>(null);
  const { changeItem } = useTimelineContext();

  const handleChange = (e: { target: { value: string } }) => {
    changeItem(item.id, (currentItem) => ({
      ...currentItem,
      text: e.target.value,
    }));
  };

  const handleBlur = () => {
    changeItem(item.id, (currentItem) => ({
      ...currentItem,
      text: item.text,
    }));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (
      ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space"].includes(
        e.key
      )
    ) {
      e.stopPropagation();
    }
  };

  const renderHorizontalAlignment = (variant: "horizontal" | "vertical") => {
    if (item.configuration.alignment[variant] === "left") {
      return "flex-start";
    }
    if (item.configuration.alignment[variant] === "center") {
      return "center";
    }
    if (item.configuration.alignment[variant] === "right") {
      return "flex-end";
    }
  };

  return (
    <ContentEditable
      innerRef={contentEditableRef}
      html={item.text}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      contentEditable={true}
      disabled
      style={{
        fontSize: item.configuration.font.size,
        color: item.configuration.font.color,
        lineHeight: item.configuration.font.lineHeight,
        left: item?.position?.x || "50%",
        top: item?.position?.y || "50%",
        display: "flex",
        userSelect: "text",
        wordsBreak: "break-word",
        padding: "0px 20px",
        outline: "none",
        justifyContent: renderHorizontalAlignment("horizontal"),
        textAlign: item.configuration.alignment.horizontal,
        alignItems: item.configuration.alignment.vertical,
        fontFamily: item.configuration.font.family,
        textDecoration: item.configuration.font.decoration,
        transform: `rotate(${item.rotation.degrees || 0}deg)`,
        backgroundColor: item.configuration.background.color,
        fontStyle:
          item.configuration.font.variant === "italic" ? "italic" : "normal",
        fontWeight: item.configuration.font.weight === "bold" ? "bold" : "none",
        width: `${item.size.width}px`,
        height: `${item.size.height}px`,
      }}
    />
  );
};
